import axios from "axios";
import { getToken } from "./auth.api";

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

api.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/*
  GET /sprint/tempos
  Relação de horas lançadas por usuário (Tempo gasto do Redmine), filtrada
  pelo período (data_inicial/data_final) da sprint em execução.

  Resposta esperada:
  {
    "periodo": { "sprint": "260701", "data_inicial": "2026-06-30", "data_final": "2026-07-07" },
    "dias": ["2026-06-30", ...],
    "desenvolvedores": [
      { "usuario": "Paulo Lima", "total": 47.5, "totais_dia": { "2026-06-30": 8 },
        "tarefas": [
          { "issue_id": 220795, "tracker": "Funcionalidade", "subject": "[BENVENUTTI] Taxa...",
            "status": "Feedback", "fechado": true, "programado": true, "sprint": "260701",
            "total": 4.67, "horas_dia": { "2026-06-30": 1.67 } }
        ]
      }, ...
    ],
    "total_geral": 123.4,
    "totais_dia_geral": { "2026-06-30": 40 }
  }
*/
export async function getTempos() {
  const { data } = await api.get("/sprint/tempos");
  return data;
}
